import * as styles from './index.module.scss';

const Spacer = () => {
  return <div className={styles.spacer} />;
};

export default Spacer;
